import React from "react";
import { Table, TableBody, TableCell, TableHead, TableRow, IconButton, Paper } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import InfiniteScroll from "react-infinite-scroll-component";
import Typography from "@mui/material/Typography";

const ReusablePaginationTable = ({
	headings,
	rows,
	handleIconClick,
	fetchData,
	hasMore,
	totalCount,
}) => {
	const theme = useTheme();

	// Calculate dynamic width based on the number of columns
	const columnWidth = `${(100 / headings.length).toFixed(2)}%`;

	return (
		<Paper sx={{ width: "100%", overflow: "hidden", margin: "0px", marginBottom: 0 }}>
			<Box sx={{ overflow: "hidden", position: "relative" }}>
				<Table sx={{ minWidth: "100%", tableLayout: "fixed" }}>
					<TableHead>
						<TableRow>
							{headings.map((heading, index) => (
								<TableCell
									key={index}
									sx={{
										fontWeight: "bold",
										backgroundColor: theme.palette.background.paper,
										zIndex: 1,
										padding: "6px 16px",
										borderBottom: `1px solid ${theme.palette.border}`,
										width: columnWidth,
										textAlign: heading.align || "left",
									}}
								>
									{heading.name}
								</TableCell>
							))}
						</TableRow>
					</TableHead>
				</Table>
			</Box>
			{/* Scrollable Body with overlay scrollbar */}
			<Box
				sx={{
					maxHeight: "calc(98vh - 300px)",
					overflowY: "auto",
					// Overlay scrollbar styles for WebKit browsers
					"&::-webkit-scrollbar": {
						width: "8px",
					},
					"&::-webkit-scrollbar-track": {
						background: "transparent",
					},
					"&::-webkit-scrollbar-thumb": {
						backgroundColor: theme.palette.background.default,
						borderRadius: "4px",
					},
					// Overlay scrollbar settings (non-standard but support in some browsers)
					scrollbarWidth: "thin", // Firefox
					scrollbarColor: theme.palette.background.default,
				}}
				id="scrollableDiv"
			>
				<InfiniteScroll
					dataLength={rows.length}
					next={() => fetchData(false)}
					hasMore={hasMore}
					loader={<Typography sx={{ textAlign: "center", padding: "10px" }}>Loading...</Typography>}
					scrollableTarget="scrollableDiv"
					initialLoad={false}
				>
					<Table sx={{ minWidth: "100%", tableLayout: "fixed" }}>
						<TableBody>
							{rows.map((row, rowIndex) => (
								<TableRow
									key={rowIndex}
									sx={{
										"& > *": {
											backgroundColor: theme.palette.secondary.main,
										},
									}}
								>
									{headings.map((heading, colIndex) => (
										<TableCell
											key={colIndex}
											sx={{
												width: columnWidth,
												padding: "2px 16px",
												textAlign: heading.align || "left",
												wordWrap: "break-word",
												overflow: "hidden",
												whiteSpace: "normal",
											}}
										>
											{heading.key
												? row[heading.key]
												: heading.icon.map((iconObj, iconIndex) => (
														<IconButton
															key={iconIndex}
															onClick={() => handleIconClick(iconObj.type, row)}
															aria-label={iconObj.type}
														>
															<iconObj.icon fontSize="small" />
														</IconButton>
													))}
										</TableCell>
									))}
								</TableRow>
							))}
						</TableBody>
					</Table>
				</InfiniteScroll>
			</Box>
			{rows.length > 0 && totalCount !== undefined && (
				<Typography sx={{ textAlign: "center", padding: "8px" }}>
					Showing {rows.length} of {totalCount}
				</Typography>
			)}
		</Paper>
	);
};

export default ReusablePaginationTable;
